import React from "react";
import { Form } from "react-bootstrap";
import { TTimeStepOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import TimeStepSelector from "../../../TimeStepSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TTimeStepOption;
}

const ForecastTimeStepsField = (props: Props) => {
  const { formik, spec } = props;
  return (
    <Form.Group controlId="timeStep">
      <Form.Label>Forecast time steps</Form.Label>
      <TimeStepSelector
        spec={spec}
        values={formik.values.time_step}
        onChange={values => formik.setFieldValue('time_step', values)}
      />

      <FormError
        message={formik.errors.time_step as TFormErrorMessage}
        when={formik.touched.time_step && Boolean(formik.errors.time_step)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default ForecastTimeStepsField;
